import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import ProductCard from "../components/ProductCard";

function Wishlist() {

  const [products, setProducts] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {

    if (!user) return;

    axios
      .get(`${API_URL}/wishlist/${user.id}`)
      .then((res) => {
        setProducts(res.data);
      })
      .catch((err) => console.log(err));

  }, []);

  const removeWishlist = async (wishlistId) => {

    try {

      await axios.delete(`${API_URL}/wishlist/${wishlistId}`);

     setProducts(
  products.filter(item => item.wishlist_id !== wishlistId)
);
    } catch (err) {
      console.log(err);
    }

  };

  return (

    <div className="products-section">

      <h2 className="section-title">
        ❤️ My Wishlist
      </h2>

      <div className="products-grid">

        {products.length > 0 ? (

          products.map((product) => (

            <div key={product.id}>

              <ProductCard product={product} />

<button
  className="remove-btn"
  onClick={() => removeWishlist(product.wishlist_id)}
>
  Remove from Wishlist
</button>
            </div>

          ))

        ) : (

          <h3>No products in wishlist.</h3>

        )}

      </div>

    </div>

  );

}

export default Wishlist;